import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {SubRegion} from '../../region-management/sub-region-management/sub-region.model';
import {tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserSubRegionSelectionService {

    private static readonly URI = environment.baseUrl + 'users/sub-regions';

    private readonly userSubRegionSelectionSubject = new Subject<void>();
    userSubRegionSelection$ = this.userSubRegionSelectionSubject.asObservable();

    constructor(private readonly httpClient: HttpClient) {
    }

    getUserSubRegions(): Observable<SubRegion[]> {
        return this.httpClient.get<SubRegion[]>(UserSubRegionSelectionService.URI);
    }

    getUserSubRegion(): Observable<number | null> {
        return this.httpClient.get<number | null>(`${UserSubRegionSelectionService.URI}/assigned`);
    }

    setUserSubRegion(subRegionId: number | null): Observable<void> {
        const params: any = {};
        if (subRegionId) {
            params.subRegionId = subRegionId;
        }
        return this.httpClient
          .post<void>(UserSubRegionSelectionService.URI, {}, {params})
          .pipe(tap(() => this.userSubRegionSelectionSubject.next()));
    }
}
